import {
  bookIconSrc,
  toolsSettingIconSrc,
  chatQuestionIconSrc,
  dmitriAvatarSrc,
  marloAvatarSrc,
  noahAvatarSrc,
} from './images';

// TODO: PER-260
export const supportArticles = [
  {
    url: 'https://docs.predictiveindex.com/perform/overview/getting-started-with-perform/',
    icon: bookIconSrc,
    title: 'Perform 101',
    description: 'Basic Getting Started guide to help you get started with PI Perform',
    authorAvatars: [marloAvatarSrc, dmitriAvatarSrc],
  },
  {
    url:
      'https://docs.predictiveindex.com/perform/apps-and-integrations-perform/video-conferencing/zoom/connecting-perform-to-zoom/',
    icon: toolsSettingIconSrc,
    title: 'Integrations',
    description: 'Getting started with our Integrations',
    authorAvatars: [marloAvatarSrc, dmitriAvatarSrc, noahAvatarSrc],
  },
  {
    url: 'https://docs.predictiveindex.com/perform/overview/getting-started-with-perform/',
    icon: chatQuestionIconSrc,
    title: 'Product FAQ',
    description: 'Frequently asked questions',
    authorAvatars: [dmitriAvatarSrc],
  },
];
